import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const deleteScheduledAbTest = {
  name: "deleteScheduledAbTest" as const,
  input: z.object({ splitId: zExt.objectId() }),
  output: z.null(),
};
